export default /* css */ `
:host {
  --oc-text-white: var(--ogm-white);
  --ogm-text-body: var(--ogm-timberwolves);
	--ogm-font-family-1: var(--oc-font-family);
	--ogm-font-family-2: var(--oc-font-family);

	--ogm-active-tab-bg-color: var(--ogm-seahawks);
	--ogm-active-tab-color: var(--ogm-pelicans);
	--ogm-text-body: var(--oc-text-body);
	--ogm-title-bg-color-2: var(--ogm-pelicans);
	--ogm-title-color-1: var(--ogm-white);

  --oc-odds-drifting-bg: rgba(255, 175, 186, 0.4);
  --oc-odds-drifting-rgb: 255, 175, 186;
  --oc-odds-drifting: #ffafba;

  --oc-odds-shortening-bg: rgba(140, 204, 242, 0.4);
  --oc-odds-shortening-rgb: 140, 204, 242;
  --oc-odds-shortening: #8cccf2;

  --ogm-grid-best-odds-primary-color: var(--ogm-pelicans);
  --ogm-grid-best-odds-secondary-color: var(--ogm-pelicans);
  --ogm-grid-best-odds-text-color: var(--ogm-seahawks);

  --ogm-grid-bookmaker-cell-border-radius-desktop: 2px;
  --ogm-grid-bookmaker-cell-border-radius-mobile: 2px;
  --ogm-grid-bookmaker-cell-height-desktop: 99px;
  --ogm-grid-bookmaker-cell-scale-desktop: 1.7;
  --ogm-grid-bookmaker-cell-width-desktop: 54px;

  --ogm-grid-cell-gap: 1px;
  --ogm-grid-cell-height-desktop: 44px;
  --ogm-grid-cell-width-desktop: 44px;

  --ogm-grid-column-height: 54px;
  --ogm-grid-column-width: 54px;

  --ogm-grid-compare-bg-color: var(--ogm-seahawks-disabled);
  --ogm-grid-compare-color: var(--ogm-timberwolves);

  --ogm-grid-main-bg-color: var(--ogm-white);
  --ogm-grid-main-border-color: var(--ogm-grizzlies);

  --ogm-grid-market-expander-margin: 0;
  --ogm-grid-odds-tooltip-bg-color: var(--ogm-seahawks);
  --ogm-grid-offer-bg-color: rgba(41, 98, 255, 0.1);
  --ogm-grid-offer-color: var(--ogm-timberwolves);
  --ogm-grid-see-all-color: var(--ogm-seahawks);
  --ogm-grid-selected-cell-bg-color: var(--ogm-seahawks);
  --ogm-grid-sticky-marketname-padding-bottom: 18px;

  --ogm-max-width: 1440px;
}

div[class*='QuickBetTooltipDisclosure'] {
	display: none;
}

:host {
	box-sizing: border-box;
	display: block;
	width: 100%;
	height: 100%;
}

.tsqd-parent-container {
	width: 50px;
	height: 50px;
	position: fixed;
	right: 5px;
	bottom: 5px;
}

[class*='BetContent'],
[class*='ExpanderContent'] {
  background-color: var(--ogm-white);
}

[class*='GridAreasContainer'] {
  margin: 0 auto;
  padding: 0 20px 20px;
}

[class*='GridContainer'] {
  color: #011f32;
  margin-right: 25px;
}

[class*='MarketHeaderWrapper'] {
  border-bottom: 1px solid var(--oc-line-secondary);
}

[class*='OddsCellBtn']:not([class*='bestOddsStyles']) {
	color: var(--oc-text-body);
}

#root {
	width: inherit;
	height: inherit;
}

*,
*:before,
*:after {
	box-sizing: inherit;

  padding: 0;
	margin: 0;
	border: 0;
	outline: 0;
	font-family: var(--oc-font-family);
	font-size: 15px;
	background: 0 0;
}

h1 {
	font-family: var(--oc-font-family);
	font-size: 26px;
	font-weight: 800;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
}

h2 {
	font-family: var(--oc-font-family);
	font-size: 22px;
	font-weight: 800;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
}

h3 {
	font-family: var(--oc-font-family);
	font-size: 18px;
	font-weight: 800;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.22;
	letter-spacing: normal;
}

h4 {
	font-family: var(--oc-font-family);
	font-size: 16px;
	font-weight: 800;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
}

.body-text-mo-2 {
	font-family: var(--oc-font-family);
	font-size: 16px;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	text-align: left;
	color: var(--text-body);
}

.body-text---mo {
	font-family: var(--oc-font-family);
	font-size: 16px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
}

.subtitle {
	font-family: var(--oc-font-family);
	font-size: 15px;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.47;
	letter-spacing: normal;
}

.body-text {
	font-family: var(--oc-font-family);
	font-size: 15px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.47;
	letter-spacing: normal;
}

.body-text-3 {
	font-family: var(--oc-font-family);
	font-size: 14px;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.36;
	letter-spacing: normal;
}

.body-text-2 {
	font-family: var(--oc-font-family);
	font-size: 14px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.36;
	letter-spacing: normal;
}

.sub-text {
	font-family: var(--oc-font-family);
	font-size: 12px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
}

.caption {
	font-family: var(--oc-font-family);
	font-size: 11px;
	font-weight: 400;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
}

.container,
.container-fluid,
.container-l,
.container-xl,
.container-xxl {
	width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}

@media (min-width: 1024px) {
	.container,
	.container-xs,
	.container-s,
	.container-m,
	.container-l {
		max-width: 930px;
		padding-right: 0;
		padding-left: 0;
	}
}

@media (min-width: 1281px) {
	.container,
	.container-xs,
	.container-s,
	.container-m,
	.container-l,
	.container-xl {
		max-width: 1000px;
	}
}

@media (min-width: 1361px) {
	.container,
	.container-xs,
	.container-s,
	.container-m,
	.container-l,
	.container-xl,
	.container-xxl {
		max-width: 1200px;
	}
}
`;
